<div class="wrapper-reponsive">
    <!-- Start màn 9 -->
    <div class="tlt-green-row mt-3">
        {{'STR_MEDICAL_EXAM_RESERVATION' | translate}}
    </div>
    <div class="content-box mt-2 mb-3 p-3" *ngIf="typeMode !== 3">
        <div class="process-step">
            <p>Step</p>
            <ul>
                <li class="active">
                    <div class="circle">
                        <span class="num">1</span>
                    </div>
                </li>
                <li class="active">
                    <div class="circle">
                        <span class="num">2</span>
                    </div>
                </li>
                <li class="active">
                    <div class="circle">
                        <span class="num">3</span>
                    </div>
                </li>
                <li class="active">
                    <div class="circle">
                        <span class="num">4</span>
                    </div>
                </li>
                <li>
                    <div class="circle">
                        <span class="num">5</span>
                    </div>
                </li>
                <li>
                    <div class="circle">
                        <span class="num">6</span>
                    </div>
                </li>
            </ul>
        </div>
    </div>
    <div class="content-box mt-2 mb-2">
        <div class="tlt-border mb-3">
            {{'STR_COURSE_SELECTION' | translate}}
            <div class="mark-right">{{'STR_REQUIRED' | translate}}</div>
        </div>
        <p class="p-2">
            {{'STR_COURSE_NOTE' | translate}}<br>
            <br>
            {{'STR_PRICE_NOTE'| translate}}<br>
            {{'STR_COURSE_NOTE_2' | translate}}
        </p>
        <div class="box-common mb-2" *ngFor="let item of lstCourse; let k = index">
            <div class="tlt-border-bot" [ngClass]="{'active': item.Checked}">
                <label class="custom-radio">
                    {{item.HTCourseName}}
                    <input type="radio" name="radio" [checked]="item.Checked" (click)="changeSelectCourse(item, false, true)">
                    <span class="checkmark"></span>
                </label>
                <div class="text-view-radius rd-10 white">
                    {{convertPrice(item.PersonalReqPrice)}} {{'STR_MONEY_UNIT' | translate}}
                </div>
            </div>
            <ul class="lst-item-border">
                <li>
                    <div class="line-dot">
                        <b>{{'STR_IMPLEMENTATION_PERIOD' | translate}}</b>
                    </div>
                    <div class="pl-4">
                        <p>
                            <span>{{item.RegStartDate | dateFormatLanguage}}</span>
                            <span>~</span>
                            <span *ngIf="!util.isNullOrBlank(item.RegEndDate)">{{item.RegEndDate |
                                dateFormatLanguage}}</span>
                        </p>
                    </div>
                </li>
                <li>
                    <div class="line-dot mb-2">
                        <b>{{'STR_EXAMINATION_ITEM' | translate}}</b>
                    </div>
                    <div class="lst-button-border green">
                        <ng-container *ngFor="let it of item.ListExaminationType1; let j = index">
                            <span class="category-name">{{it.ExaminationCategoryName}}</span>
                        </ng-container>
                    </div>
                    <div class="lst-button-border orange" *ngIf="item?.ListExaminationType2?.length > 0">
                        <div class="left-btn">
                            <span class="category-left">{{'STR_BLOOD_SAMPLING' | translate}}</span>
                        </div>
                        <ng-container *ngFor="let it of item.ListExaminationType2; let j = index">
                            <span class="category-name">{{it.ExaminationCategoryName}}</span>
                        </ng-container>
                    </div>
                </li>
            </ul>
        </div>
        <ng-container *ngIf="lstOption?.length > 0 || lstOptionCommon.length > 0">
            <div class="tlt-border mb-3">
                {{'STR_OPTION_SELECTION' | translate}}
            </div>
            <p class="pl-2" *ngIf="lstOption?.length > 0">
                {{'STR_OPTION_NOTE' | translate}}
                <br><br>
                {{'STR_PRICE_NOTE' | translate}}
            </p>
            <div class="box-common bg-common-red mb-2" *ngFor="let item of lstOption; let k = index">
                <div class="tlt-border-bot orange" [ngClass]="{'active': item.Checked}">
                    <label class="custom-checkbox">
                        {{item.HTOptionName}}
                        <input type="checkbox" [(ngModel)]="item.Checked" (change)="changeOption()">
                        <span class="checkmark"></span>
                    </label>
                    <div class="text-view-radius rd-10 white">
                        {{convertPrice(item.PersonalReqPrice)}} {{'STR_MONEY_UNIT' | translate}}
                    </div>
                </div>
            </div>
            <div class="line-dot orange" *ngIf="lstOptionCommon.length > 0">
                <b>{{'STR_FACILITY_OPTION_TITLE' | translate}}</b>
            </div>
            <p class="pl-2" *ngIf="lstOptionCommon.length > 0">{{'STR_FACILITY_OPTION_NOTE' | translate}}</p>
            <div class="box-common bg-common-red mb-2" *ngFor="let item of lstOptionCommon; let k = index">
                <div class="tlt-border-bot orange" [ngClass]="{'active': item.Checked}">
                    <label class="custom-checkbox">
                        {{item.HTOptionName}}
                        <input type="checkbox" [(ngModel)]="item.Checked" (change)="changeOption()">
                        <span class="checkmark"></span>
                    </label>
                    <div class="text-view-radius rd-10 white">
                        {{convertPrice(item.PersonalReqPrice)}} {{'STR_MONEY_UNIT' | translate}}
                    </div>
                </div>
            </div>
        </ng-container>
        <div class="box-common border-green d-flex mb-2 mt-5 box-price-width">
            <div class="tlt-dot w-50 m-0 pr-4">
                {{'STR_FEE_FRAME_TITLE' | translate}}
            </div>
            <div class="price-box-course-sel">
                <strong>{{convertPrice(objCourse.TotalPrice)}} {{'STR_MONEY_UNIT' | translate}}</strong>
            </div>
        </div>
        <p class="p-2" style="background-color: #FFF2CC;" *ngIf="CorrectAmount > 0">
            {{trans.instant('STR_EXCEED_PRICE_NOTE').replace('{0}', convertPrice(CorrectAmount))}}
        </p>
        <div class="text-center lst-button-flex mt-2">
            <button class="btn btn-common btn-bg-yellow mr-2 ml-2 mb-2" (click)="ButtonBack()">
                {{'STR_BTN_BACK' | translate}}
            </button>
            <button class="btn btn-common btn-bg-green mr-2 ml-2 mb-2" (click)="ButtonNext()" *ngIf="typeMode === 1">
                {{'STR_BTN_THE_NEXT' | translate}}
            </button>
            <button class="btn btn-common btn-bg-green mr-2 ml-2 mb-2" *ngIf="typeMode !== 1" (click)="ButtonEdit()" [disabled]="!checkChangeData()">
                {{'STR_BTN_EDIT' | translate}}
            </button>
        </div>
    </div>
    <!-- End màn 9 -->
</div>